import React from 'react'

import HomeLanding from './HomeLanding'
import HomeAbout from './HomeAbout'
import HomeCard from './HomeCard'
import Skills from './Skills.js'


export default () => {
    return (
        <div>
            <HomeLanding />
            <HomeAbout />
            <HomeCard />
            <Skills />
        </div>
    )
}
